import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";
import { articleImage } from "@/lib/images";
import { Clock3, ArrowRight, BookOpen } from "lucide-react";

export default function Guide() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-site py-16 lg:py-24" data-testid="guide-page">
      <Reveal className="max-w-2xl">
        <span className="eyebrow">Guide e articoli</span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-ink">
          I tuoi diritti, spiegati in parole semplici.
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          Guide gratuite e aggiornate su sovraindebitamento, pignoramenti, recupero crediti e
          benessere psicologico. Nessun gergo tecnico: solo ciò che ti serve sapere.
        </p>
      </Reveal>

      {loading ? (
        <p className="mt-16 text-center text-slate-500 font-semibold" data-testid="guide-loading">Caricamento delle guide…</p>
      ) : (
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.1}>
              <Link
                to={`/guide/${a.slug}`}
                data-testid={`guide-card-${a.slug}`}
                className="group flex flex-col h-full rounded-3xl border border-slate-100 bg-white p-7 shadow-sm hover:shadow-xl hover:shadow-brand-blue/8 hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300"
              >
                <div className="rounded-2xl overflow-hidden mb-5">
                <img src={articleImage(a.slug).url} alt={articleImage(a.slug).alt} loading="lazy" className="w-full h-44 object-cover transition-transform duration-700 group-hover:scale-105" data-testid={`guide-img-${a.slug}`} />
              </div>
              <div className="flex items-center justify-between">
                  <span className="inline-block rounded-full bg-brand-mist text-brand-blue text-xs font-bold uppercase tracking-wider px-3 py-1.5">
                    {a.category}
                  </span>
                  <BookOpen className="w-5 h-5 text-brand-aqua" />
                </div>
                <h2 className="mt-4 text-xl font-bold text-brand-ink leading-snug group-hover:text-brand-blue transition-colors">
                  {a.title}
                </h2>
                <p className="mt-3 text-slate-600 leading-relaxed flex-1">{a.excerpt}</p>
                <span className="mt-5 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-400">
                    <Clock3 className="w-4 h-4" /> {a.reading_min} min
                  </span>
                  <span className="inline-flex items-center gap-1.5 font-bold text-brand-blue">
                    Leggi <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
